import React from "react";
import useSWR from "swr";
import { fetcherWithToken } from "./fetcher-with-token";
import { FormCard } from "./components/form-card";
import { Label } from "./components/label";
import { renderSelectOptions } from "./render-select-options";
import { Select } from "./components/select";
import { stepStyle } from "./step.css";
import { Button } from "./components/button";
import {
  primaryButton,
  secondaryButton,
  inputVariants,
  moreInfoButton,
} from "./components/button.css";
import { formButtonsWrapper } from "./index.css";
import { MultiSelect } from "./components/multi-select";
import { Space } from "./components/space";
import { Checkbox } from "./components/checkbox";
import { Modal } from "@vagastec/ensemble-core";
import { Text } from "@vagastec/ensemble-core";
import {
  modalContentStyle,
  modalContainerImage,
  modalStyle,
} from "./step-3.css";

import { IlustracaoCanaisDePublicacao } from "./illustration/ilustracao-canais-de-publicacao";
import { useLocation } from "react-router-dom";
import { Input } from "./components/input";
import { infoIconContainer } from "./step-1.css";
import { Alert } from "./components/alert";
import { InfoIcon } from "./icons/info-icon";
import SelectLoader from "./components/select-loader";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { Multi } from "./components/multi";
import { vars } from "./theme.css";
import { Tooltip } from "./components/tooltip";
import { InfoBox } from "./components/info-box";
import { dateWrapper } from "./index.css";
import { IlustracaoCalendario } from "./illustration/ilustracao-calendario";
import { wrapperTooltipStyle } from "./components/tooltip.css";

export function Step3({ formState, setFormState, setSelectedStepId }) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [hasTriedToSubmit, setHasTriedToSubmit] = React.useState(false);
  const location = useLocation();
  const isVagaModelo = location.pathname === "/nova-vaga-modelo";
  const intl = useIntl();
  const [activeTooltipId, setActiveTooltipId] = React.useState(null);

  React.useEffect(() => {
    window.scroll(0, 0);
  }, []);

  // || location.pathname?.includes("/editar-vaga-modelo");

  // function renderSubdivisoesOptions() {
  //   if (subdivisoesError) return <option>Ocorreu um erro</option>;
  //   if (!subdivisoesData) return <option value="">Carregando...</option>;
  //   if (subdivisoesData.length)
  //     return (
  //       <>
  //         <option value="">Selecione uma opção...</option>
  //         {subdivisoesData.map((v) => (
  //           <option key={v.id} value={v.id}>
  //             {v.label_divisao} - {v.label}
  //           </option>
  //         ))}
  //       </>
  //     );
  //   return null;
  // }

  const tooltipText = [
    {
      id: 1,
      content: (
        <FormattedMessage
          id="tooltip.infoLikedin"
          defaultMessage="Fundado em 2003, o LinkedIn conecta os profissionais do mundo para torná-los mais produtivos e bem-sucedidos. Com mais de 675 milhões de membros em todo o mundo, incluindo executivos de todas as empresas da Fortune 500, o LinkedIn é a maior rede profissional do mundo."
        />
      ),
    },
    {
      id: 4,
      content: (
        <FormattedMessage
          id="tooltip.infoJooble"
          defaultMessage="Jooble é um agregador de empregos que opera em 71 países do mundo. Possui maior penetração nos países do lesteu europeu. No ranking global da categoria estão em segunda colocação, segundo a SimilarWeb. No Brasil a média de audiência é de aproximadamente 3,4 milhões de visitas por mês."
        />
      ),
    },
    {
      id: 6,
      content: (
        <FormattedMessage
          id="tooltip.infoMitula"
          defaultMessage="Mitula é um agregador de anúncios vertical com atuação em diversos segmentos como; imobiliário, automotivo e emprego. Com sede na Espanha, mas com presença global em 50 países e em 15 idiomas, possui um portfólio atual de 50 sites. o Brasil a média de audiência é de aproximadamente 3,7 milhões de visitas por mês."
        />
      ),
    },
    {
      id: 8,
      content: (
        <FormattedMessage
          id="tooltip.infoProgredir"
          defaultMessage="O Progredir é um plano de ações do governo federal para gerar emprego e renda e promover a autonomia das pessoas inscritas no Cadastro Único. Reúne qualificação profissional, apoio ao empreendedorismo e encaminhamento ao mercado de trabalho de forma rápida e eficiente."
        />
      ),
    },
    {
      id: 3,
      content: (
        <FormattedMessage
          id="tooltip.infoJobbydoo"
          defaultMessage="Jobbydoo é um agregador de empregos com sede na Itália e que está presente em 8 países. No Brasil possuem uma audiência mensal de aproximadamente 600 mil acessos por mês. Possuem serviços gratuitos para candidatos e alerta de email para novas oportunidades."
        />
      ),
    },
    {
      id: 5,
      content: (
        <FormattedMessage
          id="tooltip.infoMercadojobs"
          defaultMessage="Mercadojobs é um agregador de empregos com presença global, principalmente na América Latina e está presente em 62 países."
        />
      ),
    },
    {
      id: 7,
      content: (
        <FormattedMessage
          id="tooltip.infoTrovit"
          defaultMessage="Trovit é um agregador de anúncios vertical com atuação em diversos segmentos como; imobiliário, automotivo e emprego. Com sede na Espanha, mas com presença global em 46 países. No Brasil a média de audiência é de aproximadamente 5,5 milhões de visitas por mês."
        />
      ),
    },
    {
      id: 9,
      content: (
        <FormattedMessage
          id="tooltip.infoConecta"
          defaultMessage="O Canal Conecta é o portal de empregos exclusivo para os alunos e ex-alunos do grupo Cogna Educação, anteriormente Kroton Educacional. Um dos maiores conglomerados do segmento de educação do mundo. A companhia atende mais de 2,4 milhões de estudantes de todo o Brasil. Na graduação os principais campus são; Pitágoras, Iuni, Unopar e Anhanguera."
        />
      ),
    },
  ];

  return (
    <>
      {isModalOpen ? (
        <Modal onClose={() => setIsModalOpen(false)} className={modalStyle}>
          <div className={modalContentStyle}>
            <div>
              <Text size="xl" weight={600} as="h2">
                <FormattedMessage
                  id="step3.tituloModal"
                  defaultMessage="Impacte milhões de candidatos com um clique!"
                />
              </Text>
              <Space />
              <Text size="sm" as="p">
                <FormattedMessage
                  id="step3.infoModal"
                  defaultMessage="Fizemos a integração com diferentes parceiros para que
                        você amplie sua divulgação e administre seu processo
                        seletivo em um único canal: o VAGAS for Business. Basta
                        selecionar os canais parceiros e em até
                        <strong> 72h </strong> eles farão a sua publicação sem
                        nenhum custo adicional!"
                  values={{
                    strong: (chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </Text>
              <Space />
              <Button
                className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                onClick={() => setIsModalOpen(false)}
              >
                <FormattedMessage
                  id="step3.okModal"
                  defaultMessage="Ok, entendi!"
                />
              </Button>
            </div>
            <div className={modalContainerImage}>
              <IlustracaoCanaisDePublicacao />
            </div>
          </div>
        </Modal>
      ) : null}
      <form
        className={stepStyle}
        onSubmit={(e) => {
          e.preventDefault();
          setSelectedStepId(4);
        }}
      >
        {!isVagaModelo ? (
          <FormCard
            title={
              <FormattedMessage
                id="step2.periodoInscricao"
                defaultMessage="Período de Inscrição *"
              />
            }
            description={
              <FormattedMessage
                id="step2.infoPeriodoInscricao"
                defaultMessage="Informe uma data-limite para receber candidaturas."
              />
            }
            data-testid="bloco-periodo"
          >
            <div className={dateWrapper}>
              <Input
                type="date"
                label={
                  <FormattedMessage
                    id="step2.inicio"
                    defaultMessage="Data de início"
                  />
                }
                variant="inline"
                required
                data-testid="input-data-inicio"
                value={formState.dataInicio}
                onChange={(e) =>
                  setFormState({
                    dataInicio: e.target.value,
                  })
                }
                // min={new Date().toISOString().slice(0, 10)}
                errorMessage={
                  <FormattedMessage
                    id="step2.erroData"
                    defaultMessage="Data inválida"
                  />
                }
              ></Input>

              <Space />
              <Input
                type="date"
                label={
                  <FormattedMessage
                    id="step2.fim"
                    defaultMessage="Data final"
                    description="Fim do período de inscrições"
                  />
                }
                variant="inline"
                required
                data-testid="input-data-fim"
                value={formState.dataFim}
                onChange={(e) =>
                  setFormState({
                    dataFim: e.target.value,
                  })
                }
                errorMessage={
                  <FormattedMessage
                    id="step2.erroData"
                    defaultMessage="Data inválida"
                  />
                }
              ></Input>
            </div>

            <Space />

            <Checkbox
              label={
                <FormattedMessage
                  id="step2.interromperInscricoes"
                  defaultMessage="Interromper inscrições (suspender vaga)"
                />
              }
              checked={formState.isSuspenderVaga}
              onChange={(e) =>
                setFormState({ isSuspenderVaga: e.target.checked })
              }
              data-testid="checkbox-interromper-inscricoes"
            />

            <Space />

            {formState.painelData?.funcionario.admin ? (
              <InfoBox
                illustration={<IlustracaoCalendario />}
                title={
                  <FormattedMessage
                    id="step2.titleSla"
                    defaultMessage="Você sabia que pode controlar seu SLA?"
                  />
                }
                description={
                  <FormattedMessage
                    id="step2.descriptionSla"
                    defaultMessage="Acesse relatórios, monitore o seu desempenho e atue estrategicamente!"
                  />
                }
                actionContent={
                  <a
                    href={`${process.env.GLOBAL_URL}/configuracoes/sla`}
                    className={`${secondaryButton} ${inputVariants["form-buttons"]}`}
                    style={{ textDecoration: "none", color: vars.color.brand }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage
                      id="step2.configurarSla"
                      defaultMessage="Configurar"
                    />
                  </a>
                }
              ></InfoBox>
            ) : null}
          </FormCard>
        ) : null}

        {!isVagaModelo ? (
          <FormCard
            title={
              <FormattedMessage
                id="step3.titleAcessoRestrito"
                defaultMessage="Acesso restrito (vaga-teste)"
              />
            }
            description={
              <FormattedMessage
                id="step3.descriptionAcessoRestrito"
                defaultMessage="Esta vaga só será acessada por quem tiver acesso ao link (URL) da vaga. 
            Não aparecerá como resultado de buscas dentro do VAGAS.com."
              />
            }
            data-testid="bloco-acesso-restrito"
          >
            <Checkbox
              label={
                <FormattedMessage
                  id="step3.checkboxVagaRestrita"
                  defaultMessage="Deixar esta vaga restrita"
                />
              }
              checked={formState.isVagaTeste}
              onChange={(e) => {
                if (!e.target.checked) {
                  setFormState({
                    senhaVagaTeste: "",
                  });
                }
                setFormState({ isVagaTeste: e.target.checked });
              }}
              data-testid="checkbox-vaga-teste"
            />

            <Space height="1rem" />

            <Input
              label={
                <FormattedMessage
                  id="step3.senha"
                  defaultMessage="Senha (opcional)"
                />
              }
              placeholder={intl.formatMessage(
                defineMessage({
                  id: "step1.placeholderSenha",
                  defaultMessage: "Insira uma senha para acessar a vaga.",
                })
              )}
              data-testid="input-senha"
              type="text"
              value={formState.senhaVagaTeste}
              onChange={(e) => setFormState({ senhaVagaTeste: e.target.value })}
            />
          </FormCard>
        ) : null}

        <FormCard
          title={
            <FormattedMessage
              id="step3.canaisDivulgacao"
              defaultMessage="Canais de divulgação"
            />
          }
        >
          {!formState.divisaoData && !isVagaModelo ? (
            <SelectLoader />
          ) : (
            <>
              {!isVagaModelo ? (
                <>
                  {formState.isAnuncioConfidencial ? (
                    <Alert>
                      <div className={infoIconContainer}>
                        <InfoIcon width={20} height={20} />
                      </div>
                      <Text size="sm" as="p">
                        <FormattedMessage
                          id="step1.infoVagaConfidencial"
                          defaultMessage="Esta vaga é confidencial. Divisões de recrutamento
                interno não serão exibidas no campo <strong>Divisão</strong>"
                          values={{
                            strong: (chunks) => <strong>{chunks}</strong>,
                          }}
                        />
                      </Text>
                    </Alert>
                  ) : null}
                  <Label
                    text={
                      <FormattedMessage
                        id="step3.divisao"
                        defaultMessage="Divisão *"
                      />
                    }
                    details={
                      <FormattedMessage
                        id="step3.divisaoInfo"
                        defaultMessage="(escolha onde a vaga será divulgada dentro da sua organização)"
                      />
                    }
                  >
                    <Select
                      value={formState.divisaoSelectedId}
                      onChange={(e) =>
                        setFormState({
                          divisaoSelectedId: Number(e.target.value),
                        })
                      }
                      required
                      shouldValidate={hasTriedToSubmit}
                      errorMessage={
                        <FormattedMessage
                          id="erro.campoObrigatorio"
                          defaultMessage="Campo obrigatório"
                        />
                      }
                      data-testid="select-divisao"
                    >
                      {renderSelectOptions({
                        data: formState.divisaoData,
                        error: formState.divisaoError,
                        errorMessage: intl.formatMessage(
                          defineMessage({
                            id: "select.erro",
                            defaultMessage: "Ocorreu um erro",
                          })
                        ),
                        loadingMessage: intl.formatMessage(
                          defineMessage({
                            id: "select.loading",
                            defaultMessage: "Carregando...",
                          })
                        ),
                        selectOptionMessage: intl.formatMessage(
                          defineMessage({
                            id: "select.escolherOpcao",
                            defaultMessage: "Selecione uma opção...",
                          })
                        ),
                      })}
                    </Select>
                  </Label>
                  <Space />
                </>
              ) : null}
            </>
          )}

          {!formState.isVagaTeste ? (
            <>
              <Label
                text={
                  <FormattedMessage
                    id="step3.canaisParceiros"
                    defaultMessage="Canais parceiros"
                  />
                }
                details={
                  <FormattedMessage
                    id="step3.canaisDivulgacaoInfo"
                    defaultMessage="(amplie sua divulgação publicando também em outros canais. <button ></button>)"
                    values={{
                      button: (chunks) => (
                        <Button
                          className={moreInfoButton}
                          onClick={() => setIsModalOpen(true)}
                          data-testid="btn-saiba-mais"
                        >
                          <FormattedMessage
                            id="step3.modalSaibaMais"
                            defaultMessage="Saiba Mais"
                          />
                        </Button>
                      ),
                    }}
                  />
                }
              >
                <Space height="1rem" />
                <div
                  style={{ display: "grid", gridTemplateColumns: "50% 50%" }}
                >
                  {!formState.canaisDivulgacaoData ? (
                    <>
                      <Label
                        text={
                          <FormattedMessage
                            id={`${
                              formState.canaisDivulgacaoError
                                ? "mensagem.ocorreuErro"
                                : "info.carregando"
                            }`}
                            defaultMessage={`${
                              formState.canaisDivulgacaoError
                                ? "Ocorreu um erro"
                                : "Carregando..."
                            }`}
                          />
                        }
                      />
                    </>
                  ) : (
                    formState.canaisDivulgacaoData?.map((canal) => (
                      <div
                        key={`${canal.id}-${canal.label}`}
                        className={wrapperTooltipStyle}
                      >
                        <Checkbox
                          label={
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={canal.imagem}
                                alt={`logotipo ${canal.label}`}
                                width="50px"
                                height="40px"
                              ></img>
                              <Space />
                              {canal.label}
                            </div>
                          }
                          checked={
                            formState.canaisDivulgacaoSelected?.find(
                              (item) => item.id === canal.id
                            ) ?? false
                          }
                          onChange={(e) => {
                            setFormState({
                              canaisDivulgacaoSelected: e.target.checked
                                ? [...formState.canaisDivulgacaoSelected, canal]
                                : formState.canaisDivulgacaoSelected?.filter(
                                    (item) => item.id !== canal.id
                                  ),
                            });
                          }}
                          aria-label={`selecionar ${canal.label}`}
                        />

                        <Tooltip
                          active={activeTooltipId === canal.id}
                          setActive={(active) =>
                            setActiveTooltipId(active ? canal.id : null)
                          }
                          text={
                            tooltipText.find((v) => v.id === canal.id).content
                          }
                        />
                        <Space height="3.875rem" />
                      </div>
                    ))
                  )}
                </div>
              </Label>
            </>
          ) : null}
        </FormCard>

        {isVagaModelo ? (
          <>
            <FormCard
              title={
                <FormattedMessage
                  id="step3.divisoesAcesso"
                  defaultMessage="Divisões com acesso *"
                />
              }
              data-testid="select-divisoes-acesso"
            >
              <Multi
                name="divisoesComAcesso"
                options={formState.divisoesAcessoData}
                required
                state={formState.divisoesAcessoSelected}
                onChange={(v) => {
                  setFormState({ divisoesAcessoSelected: v });
                }}
                getOptionValue={(option) => option.id}
                noOptionsMessage={() => {
                  return formState.divisoesAcessoError ? (
                    <FormattedMessage
                      id="mensagem.ocorreuErro"
                      defaultMessage="Ocorreu um erro"
                    />
                  ) : (
                    <FormattedMessage
                      id="step1-limiteOpcoes"
                      defaultMessage="Não há mais opções disponíveis."
                    />
                  );
                }}
                placeholder={
                  <Text size="sm" fontColor={vars.color.lightForeground}>
                    <FormattedMessage
                      id="placeholder.pesquiseSelecione"
                      defaultMessage="Pesquise e selecione"
                    />
                  </Text>
                }
                errorMessage={
                  <FormattedMessage
                    id="erro.campoObrigatorio"
                    defaultMessage="Campo obrigatório"
                  />
                }
                shouldValidate={hasTriedToSubmit}
                data-testid="select-divisoes-acesso"
              ></Multi>
            </FormCard>
          </>
        ) : null}

        <div className={formButtonsWrapper}>
          <Button
            className={`${secondaryButton} ${inputVariants["form-buttons"]}`}
            type="button"
            data-testid="btn-voltar"
            onClick={() => setSelectedStepId(2)}
          >
            <FormattedMessage id="botao.voltar" defaultMessage="Voltar" />
          </Button>
          <Space />
          <Button
            className={`${primaryButton} ${inputVariants["form-buttons"]}`}
            type="submit"
            onClick={() => setHasTriedToSubmit(true)}
            data-testid="btn-continuar"
            disabled={isVagaModelo && !formState.divisoesAcessoSelected?.length}
            id="continuar-para-step4"
          >
            <FormattedMessage id="botao.continuar" defaultMessage="Continuar" />
          </Button>
        </div>
      </form>
    </>
  );
}
